import { render, staticRenderFns } from "./BodyPartForm.vue?vue&type=template&id=3518ea1b&"
import script from "./BodyPartForm.vue?vue&type=script&lang=js&"
export * from "./BodyPartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports